<template>
    <div>
      <!-- Top bar -->
      <div class="nav-bar-operations">
        <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
      </div>
      <div class="text-operations"></div>
  
      <!-- Header -->
      <div class="panel-head">
        <h3>Reporte de Venta Diaria</h3>
        <img src="@/assets/filtros.png" alt="filtros" />
      </div>
  
      <!-- Filters (form => Enter submits) -->
      <form
        class="filters-card"
        @submit.prevent="handleSubmit"
        @keydown.enter.prevent="handleSubmit"
      >
        <!-- Fechas -->
        <div class="row">
          <label>Fecha</label>
          <input type="date" v-model="startDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
          <span class="sep">al</span>
          <input type="date" v-model="endDate" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }" />
        </div>
  
        <!-- Cliente con sugerencias -->
        <div class="row row-rel">
          <label for="client_name">Cliente</label>
          <input
            id="client_name"
            type="text"
            v-model="clientName"
            placeholder="Ingrese el cliente a buscar"
            @input="filterClients"
            autocomplete="off"
          />
          <span class="sep"></span>
          <div class="cell"></div>
          <ul v-if="filteredClients.length" class="suggestions-list">
            <li
              v-for="(client, index) in filteredClients"
              :key="index"
              @click="selectClient(client)"
            >
              {{ client.client_ident + ' - ' + client.client_name }}
            </li>
          </ul>
        </div>
  
        <!-- Número de Cliente -->
        <div class="row">
          <label for="clientIdentStart">Número de cliente</label>
          <input id="clientIdentStart" type="text" v-model="clientIdentStart" placeholder="Inicio" />
          <span class="sep">al</span>
          <input id="clientIdentEnd" type="text" v-model="clientIdentEnd" placeholder="Fin" />
        </div>
  
        <!-- Número de Factura -->
        <div class="row">
          <label for="invoiceNumberStart">Número de factura</label>
          <input id="invoiceNumberStart" type="text" v-model="invoiceNumberStart" placeholder="Inicio" />
          <span class="sep">al</span>
          <input id="invoiceNumberEnd" type="text" v-model="invoiceNumberEnd" placeholder="Fin" />
        </div>
  
        <!-- Sucursal (full width) -->
        <div class="row">
          <label for="sucursal">Sucursal</label>
          <select id="sucursal" v-model="sucursal" class="form-select span-3" :disabled="blockEdit" :class="{ 'grayed-out': blockEdit }">
            <option v-for="opt in $catalogs.sucursales" :key="opt" :value="opt">{{ opt }}</option>
          </select>
        </div>
  
        <!-- Tipo de servicio -->
        <div class="row">
          <label for="type">Tipo de servicio</label>
          <select id="type" v-model="type" class="form-select">
            <option value="" disabled selected>Seleccione un tipo de servicio</option>
            <option :value="2">Remolque</option>
            <option :value="1">Auxilio vial</option>
            <option :value="4">Lote</option>
            <option :value="3">Montacargas</option>
            <option :value="5">Industrial</option>
          </select>
          <span class="sep"></span>
          <div class="cell"></div>
        </div>
  
        <!-- Actions -->
        <div class="row actions">
          <div class="cell span-4">
            <button type="submit" class="btn-submit-save" :disabled="isGeneratingReport">
              {{ isGeneratingReport ? 'Generando reporte...' : 'Generar reporte' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </template>
  
  <style scoped>
  /* Top bar (kept) */
  .nav-bar-operations {
    position: absolute; top: 0; left: 0; width: 100%; height: 10vh;
    background-color: #FFC434; z-index: 1000; margin: 0;
  }
  .logo-button { position: absolute; height: 90%; top: 50%; left: 50%; transform: translate(-50%, -50%); cursor: pointer; margin: 0; }
  .text-operations { margin-top: 10vh; width: 100%; height: 5vh; border-bottom: 1px solid #000; background: #fff; }
  
  .panel-head { margin: 10px 8px 6px; display: flex; align-items: center; gap: 8px; }
  .panel-head h3 { font-size: 1.15rem; margin: 0; }
  .panel-head img { width: 24px; height: 24px; }
  
  /* Filters card */
  .filters-card{
    --label-w: 200px;
    --ctrl-w: 360px;
    --sep-w: 22px;
    --gap: 8px;
    --h: 36px;
    --fs: 14px;
    --fs-small: 12px;
    --pad-x: 10px;
    --radius: 10px;
  
    margin: 10px 8px 16px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 12px;
    padding: 14px;
    box-shadow: 0 2px 10px rgba(0,0,0,.06);
    display: grid; gap: 10px;
  }
  .filters-card .row{
    display: grid;
    grid-template-columns: var(--label-w) var(--ctrl-w) var(--sep-w) var(--ctrl-w);
    align-items: center;
    gap: var(--gap);
  }
  .filters-card .row.actions { grid-template-columns: 1fr; }
  .filters-card .row-rel { position: relative; }
  .filters-card label { font-size: var(--fs); color:#222; white-space: nowrap; }
  .filters-card .sep { text-align: center; color:#666; font-size: var(--fs-small); }
  
  .filters-card input[type="text"],
  .filters-card input[type="date"],
  .filters-card select{
    height: var(--h);
    padding: 0 var(--pad-x);
    border: 1px solid #d5d5d5;
    border-radius: var(--radius);
    font-size: var(--fs);
    outline: none; width: 100%;
  }
  .filters-card input:focus, .filters-card select:focus{
    border-color:#b3b3b3;
    box-shadow:0 0 0 3px rgba(255,196,52,.22);
  }
  
  /* Full-width control */
  .filters-card .span-3 { grid-column: 2 / -1; }
  
  /* Suggestions dropdown (aligned to first control column) */
  .suggestions-list{
    position: absolute;
    top: calc(var(--h) + 6px);
    left: var(--label-w);
    width: var(--ctrl-w);
    max-height: 260px;
    overflow-y: auto;
    list-style: none; margin:0; padding:0;
    background:#fff; border:1px solid #ddd; border-radius:10px;
    box-shadow:0 10px 28px rgba(0,0,0,.12);
    z-index: 2000;
    font-size: var(--fs);
  }
  .suggestions-list li{ padding:8px 10px; cursor:pointer; }
  .suggestions-list li:hover{ background:#f0f8ff; font-weight:600; }
  
  .filters-card .cell{ height:0; }
  .filters-card .span-4{ grid-column: 1 / -1; }
  .grayed-out{ background:#f5f5f5; color:#999; }
  
  /* Button */
  .btn-submit-save{
    padding: 10px 14px; font-size: .95rem; border-radius: 10px;
    background:#FFC434; border:none; cursor:pointer; font-weight:600;
    box-shadow:0 2px 6px rgba(0,0,0,.08);
  }
  .btn-submit-save:hover{ background:#e6b12e; }
  
  /* Responsive */
  @media (max-width: 1200px){
    .filters-card { --ctrl-w: 300px; }
  }
  @media (max-width: 980px){
    .filters-card { --label-w: 150px; --ctrl-w: 1fr; }
    .filters-card .row { grid-template-columns: var(--label-w) 1fr; }
    .filters-card .sep, .filters-card .row > .cell { display: none; }
    .suggestions-list{ left: 0; width: 100%; }
  }
  </style>
  
  <script>
  import axios from 'axios';
  import Swal from 'sweetalert2';
import { showReportLoading, hideReportLoading } from '@/utils/reportLoading';
  import Fuse from 'fuse.js';
  
  export default {
    data() {
      return {
        startDate: '',
        endDate: '',
        clientIdentStart: '',
        clientIdentEnd: '',
        sucursal: '',
        type: '',
        clients: [],
        filteredClients: [],
        clientName: '',
        invoiceNumberStart: '',
        invoiceNumberEnd: '',
        fuse: '',
        blockEdit: false,
        isGeneratingReport: false,
      };
    },
  
    computed: {
      effectiveEndDate() {
        return this.endDate || this.startDate;
      },
      effectiveEndClient() {
        return this.clientIdentEnd || this.clientIdentStart;
      },
      effectiveEndInvoice() {
        return this.invoiceNumberEnd || this.invoiceNumberStart;
      },
    },
  
    methods: {
      async fetchClients() {
        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.get(`${apiDirectory}/get-privileged-clients`);
          this.clients = response.data;
          this.initializeFuse();
        } catch (error) {
          console.error('Error fetching clients:', error);
        }
      },
      initializeFuse() {
        const options = {
          keys: ['client_name', 'client_ident'],
          threshold: 0.3,
          ignoreLocation: true,
          includeScore: false,
        };
        this.fuse = new Fuse(this.clients, options);
      },
      filterClients() {
        const q = (this.clientName || '').trim();
        if (!q) { this.filteredClients = []; return; }
        this.filteredClients = this.fuse ? this.fuse.search(q).map(r => r.item) : [];
      },
      selectClient(client) {
        this.clientName = client.client_name;
        //this.clientIdentStart = client.client_ident;
        this.filteredClients = [];
      },
      formatToDatetime(date, time) {
        if (!date) return '';
        return `${date}T${time}`;
      },
      backMainPanel() {
        window.location.href = '/main-panel';
      },
  
      validateClientIdentRange() {
        if (this.clientIdentStart !== '' && this.clientIdentEnd === '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'Debe ingresar un número de cliente final cuando ingresa un número inicial' });
          return false;
        }
        if (this.clientIdentStart === '' && this.clientIdentEnd !== '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'No puede ingresar un número de cliente final sin un número inicial' });
          return false;
        }
        if (this.clientIdentStart !== '' && this.clientIdentEnd !== '') {
          const a = parseInt(this.clientIdentStart, 10);
          const b = parseInt(this.clientIdentEnd, 10);
          if (Number.isFinite(a) && Number.isFinite(b) && b < a) {
            Swal.fire({ icon:'error', title:'Error de validación', text:'El número de cliente final debe ser mayor o igual al inicial' });
            return false;
          }
        }
        return true;
      },
      validateInvoiceNumbers() {
        if (this.invoiceNumberStart !== '' && this.invoiceNumberEnd === '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'Debe ingresar un número de factura final cuando ingresa un número inicial' });
          return false;
        }
        if (this.invoiceNumberStart === '' && this.invoiceNumberEnd !== '') {
          Swal.fire({ icon:'error', title:'Error de validación', text:'No puede ingresar un número de factura final sin un número inicial' });
          return false;
        }
        if (this.invoiceNumberStart !== '' && this.invoiceNumberEnd !== '') {
          const a = parseInt(this.invoiceNumberStart, 10);
          const b = parseInt(this.invoiceNumberEnd, 10);
          if (Number.isFinite(a) && Number.isFinite(b) && b < a) {
            Swal.fire({ icon:'error', title:'Error de validación', text:'El número de factura final debe ser mayor o igual al inicial' });
            return false;
          }
        }
        return true;
      },
  
      async generateReport() {
        if (this.isGeneratingReport) return;
        // Stop if ANY validation fails
        if (![this.validateClientIdentRange(), this.validateInvoiceNumbers()].every(Boolean)) return;
  
        const payload = {
          start_date: this.formatToDatetime(this.startDate, '00:00'),
          end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
          client_ident_start: this.clientIdentStart,
          client_ident_end: this.effectiveEndClient,
          sucursal: this.sucursal,
          type: this.type,
          client_name: this.clientName,
          invoice_start: this.invoiceNumberStart,
          invoice_end: this.effectiveEndInvoice,
        };
  
        this.isGeneratingReport = true;
        showReportLoading();

        try {
          const apiDirectory = process.env.API_DIRECTORY;
          const response = await axios.post(`${apiDirectory}/reports/daily-sales-report`, payload, {
            responseType: 'blob',
          });
  
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'venta_diaria.zip');
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        } catch (error) {
          const errorMessage = error?.response?.data?.error || error.message;
          Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage });
        } finally {
          this.isGeneratingReport = false;
          hideReportLoading();
        }
      },
  
      handleSubmit() {
        this.generateReport();
      },
    },
  
    mounted() {
      this.fetchClients();
    },
  };
  </script>
  